import cx from "classnames";
import { TwoTierNav } from "common/TwoTierNav";
import * as reportActions from "lib/api/rideReports";
import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import appStyles from "../../App/appStyles.scss";
import { rrSubnav } from "../../IndexPage";
import { VoteBody } from "./VoteBody";
import styles from "./VotePage.scss";

export class VotePage extends React.PureComponent {
  render() {
    const { finalistIds, votedIds, reports, onChangeRoute, currentUser, draftCount } = this.props;

    return (
      <div className={cx(styles.VotePage, appStyles.base)}>
        <Helmet title="Ride Report Rollout Finalist Voting" />
        <TwoTierNav secondaryNav={rrSubnav({ currentUser, draftCount })} />
        <div className={styles.hero}>
          <div className={styles.heroLeft}>
            <h1>Report Rollout Finalists</h1>
            <p>
              These ten finalists have been selected from hundreds of submissions for their compelling stories,
              top-notch photography, and adventurous source material. We hope you enjoy reading them, and we need your
              help to pick a winner for our grand prize - a fully-custom bike from Breadwinner Cycles, ready for any
              adventure our first-place author can throw at it!
            </p>
            <p className={styles.shouty}>
              Grand Prize
              <br />
              Breadwinner B-Road Gravel Grinder Bike
            </p>
          </div>
          <div className={styles.heroRight}>
            <img src="/images/ride_reports_rollout/finalist_page_hero.jpg" />
          </div>
        </div>
        <VoteBody finalistIds={finalistIds} reports={reports} votedIds={votedIds} onChangeRoute={onChangeRoute} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  finalistIds: state.rolloutContest.finalistIds,
  votedIds: state.rolloutContest.votedIds,
  reports: state.rideReports.reports,
  currentUser: state.currentUser,
  draftCount: state.editPage.draftList.size,
});

const mapDispatchToProps = {
  loadReport: reportActions.loadReport,
};

export const VotePageContainer = connect(mapStateToProps, mapDispatchToProps)(VotePage);
